document.addEventListener('leat:initialized', () => {
    setTimeout(() => {
        const tiersDataEl = document.querySelector('[data-leat-tiers-objects]');
        const currentTierEl = document.querySelector('[data-leat-tier="current"]');
        const currentPointsEl = document.querySelector('.leat-customer-points-value');

        if (!tiersDataEl || !currentTierEl || !currentPointsEl) return;

        const tiersObjects = JSON.parse(
            tiersDataEl.getAttribute('data-leat-tiers-objects')
        );

        const currentTier = currentTierEl.textContent;
        const currentTierPoints = Number(currentPointsEl.textContent);

        const getNextTier = (points) =>
            [...tiersObjects]
                .sort((a, b) => a.points - b.points)
                .find(tier => tier.points > points) || null;

        const nextTierObject = getNextTier(currentTierPoints);
        if (!nextTierObject) return;

        const nextTierEl = document.querySelector('[data-leat-next-tier]');
        const nextPointsEl = document.querySelector('[data-tier-gauge-next-points]');
        const progressEl = document.querySelector('[data-tier-gauge-progress]');

        if (nextTierEl) nextTierEl.textContent = nextTierObject.title;
        if (nextPointsEl) nextPointsEl.textContent = nextTierObject.points;

        if (progressEl) {
            const progress = (currentTierPoints / nextTierObject.points) * 100;
            progressEl.style.width = `${progress}%`;
        }

        if (tiersDataEl) {
            tiersDataEl.classList.add('active');
        }
    }, 1000);
});